import VideoHelper from "../video/VideoHelper";

export default function handleVideos(){
    $('body').on('click', '.js-video-play', function(){
        let videoPlayer = null;
        let $parent = $(this).parents('.js-video');
        let video_type = $parent.data('type');
        $parent.addClass('video--playing');

        if(video_type === 'upload'){
            $parent.find('video').get(0).play();
        } else {
            let url = $parent.find('.js-youtube-player').data('url');
            let information = getVideoInformationFromUrl(url);

            if (information === null) return;
            videoPlayer = VideoHelper.process(information.provider, information.videoId, $parent.find('.js-youtube-player'), {});
            videoPlayer.on('loaded', () => {
                videoPlayer.play();
            });
        }
    });
}

function getVideoInformationFromUrl(url) {
    let YoutubeTest = new RegExp(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_YOUTUBE].url);
    if (YoutubeTest.test(url)) {
        return {
            "provider": VideoHelper.PROVIDER_YOUTUBE,
            "videoId": url.match(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_YOUTUBE].url)[1]
        }
    }
    let VimeoTest = new RegExp(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_VIMEO].url);
    if (VimeoTest.test(url)) {
        return {
            "provider": VideoHelper.PROVIDER_VIMEO,
            "videoId": url.match(VideoHelper.PROVIDERS[VideoHelper.PROVIDER_VIMEO].url)[1]
        }
    }

    return null;
}
